import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSite = _resolveComponent("SelectSite")!

  return (_openBlock(), _createBlock(_component_SelectSite, {
    onFilterChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pick(undefined))),
    class: "step-one-container",
    onPick: _ctx.pick,
    selectedSite: _ctx.selectedSite,
    title: _ctx.$t('siteSelection.searchBar.title.reclamation')
  }, null, 8, ["onPick", "selectedSite", "title"]))
}